<template> 
<b-form-group align="left">
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label> Hora de inicio:: </label> 
    <vue-timepicker v-model="horaInicio" hide-disabled-items format="HH:mm" 
        close-on-complete></vue-timepicker>
</b-form-group>
</template>

<script>
export default {
    name: "HoraInicio",
    props: { 
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        horaInicio: null,  
    }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    methods: { 
    },
    mounted() { 
    }, 
}
</script>
